<template>
    <div id="app">
        <section style="display:none">
            <!-- <h2 style="">搜索结果</h2> -->
            <!-- <el-select v-model="body.sort_type" @change="sortChange" placeholder="默认排序" style="width: 162px;padding-right: 60px;">
                <el-option v-for="item in sort" :key="item.id" :label="item.value" :value="item.id"></el-option>
            </el-select> -->
        </section>
        <div class="result">
            <template>
                <div class="tips" v-if="list.length">
                    <p>*爱集微人才库目前已面向各企业开通人才简历搜索功能，目前处于试用阶段，企业每日可限量查看{{resume_view.total_view}}份简历</p>
                    <span>今日已查看简历数：{{resume_view.view}}</span>
                </div>
                <TablePage class="result-table" :data="list" :columns="columns" :page="page" @pageChange="pageChange"></TablePage>
            </template>
        </div>
    </div>
</template>
<script>
    import TablePage from "@/components/TablePage"
    import $api from "@/api/ResumeModule"
    export default {
        components: { TablePage },
        props: [
            'par'
        ],
        data() {
            return {
                body: {},
                sort: [
                    { id: "0", value: '默认排序' },
                    { id: "1", value: '按薪资由低到高' },
                    { id: "2", value: '按学历由低到高' },
                    { id: "3", value: '按工作年限由高到底' }
                ],
                value: '',
                list: [],
                resume_view: {},
                columns: [
                    {
                        prop: 'avatar',
                        width: 76,
                        align: 'center',
                        render: (h, scope) => {
                            return ( <
                                div > < img style = "display:flex;justify-content:center;align-items:center;width: 56px; height: 56px; border-radius: 18px;"
                                src = { scope.row.avatar } onerror = { scope.row.defaultimg }
                                /></div >
                            )
                        },
                    },
                    { 
                        width: 120, align: 'left' ,
                        render: (h, scope) => {
                            return ( 
                                <div style = "display:flex;flex-direction: column;border-right: 1px solid #EFEFEF;height: 90px;justify-content: center;">
                                <h5 style="font-size: 16px;font-family: MicrosoftYaHeiSemibold;color: #333333;line-height: 21px;">{ scope.row.name }</h5>
                                <p style="font-size: 14px;font-family: MicrosoftYaHei;color: #333333;line-height: 19px;margin-top:8px;">{ scope.row.tel }</p>
                                </div >
                                
                            )
                        },
                    },
                    {   
                        width: 569,
                        align: 'left' ,
                        render: (h, scope) => {
                            return ( 
                                <div>
                                    <div style = "font-size: 14px;font-family: MicrosoftYaHei;color: #333333;line-height: 19px;">
                                    <span>{ scope.row.user_info }</span>
                                    {
                                        scope.row.educ_list.map(item => {
                                            return <span style = "margin-left:20px"><span>{item.school}</span><span style = "margin-left:10px">{ item.major}</span></span>
                                        })
                                    }
                                    <span style = "margin-left:20px">{ scope.row.job_status }</span>
                                    </div >
                                    {
                                        scope.row.project_list.map(item => {
                                            return <div style = "font-size: 12px;font-family: MicrosoftYaHei;margin-top: 3px;"><span style = "padding-right: 5px;color:#666666;">{item.start_time}-{item.end_time}</span>|<span style = "padding: 5px;color:#666666;">{ item.company}</span>|<span style = "padding-left: 5px;color:#666666;">{ item.position_name}</span><p style="margin-top: 5px;min-height: 40px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;color: #999999;line-height: 20px;">{ item.project }</p></div>
                                        })
                                    }
                                </div>
                            )
                        },
                    },

                    {
                        align: 'right' ,width:255,
                        render: (h, scope) => {
                            return h('div',{
                                attrs:{
                                        'style':'display: flex;flex-direction: column;align-items: end;height: 90px;justify-content: space-between;'
                                    }
                                },[
                                scope.row.wish_list.map(item => {
                                    return <p style="color:#333333;line-height: 19px;"><span style="color:#666666">求职意向：</span>{item.wish_position_name}</p>
                                }),
                                
                                h('div',{
                                    attrs:{
                                        'style':'width: 140px;display: flex;justify-content: space-between;'
                                    }
                                }, [
                                    h('button', {
                                        class: 'table-btn-show'
                                    }, [`${scope.row.is_view===0?'':'今日已获取'}`]),

                                    h('button', {
                                        class: `${(this.resume_view.view===this.resume_view.total_view)&&scope.row.is_view===0?'table-btn-disable':'table-btn'}`,
                                        on: { click: () => { this.gotolink(scope.row.id,scope.row.created_at,scope.row.is_view) } }
                                    }, [`${scope.row.is_view===0?'获取简历＞':'在线简历＞'}`])
                                ])
                            ])
                        }
                    }
                ],
                page: {}
            }
        },
        watch: {
            $route(to, from) {
                    if (from.name === "ResumeDetailsForSearch") {
                        this.getData(JSON.stringify(this.par)==="{}"?{limit:10}:this.par);
                    } 
                }
        },
        created() {
            this.getData({limit:10});
        },
        //激活keep-alive触发
        activated() {
            //页面跳转
            // this.body = this.$route.query.body ? JSON.parse(this.$route.query.body) : this.body;
            // this.getData();
        },
        deactivated() {
            //销毁
        },
        methods: {
            empty(){
                this.list = [];
                this.body.sort_type = '';
            },
            getData(e) {
                $api.getResumeList(e)
                .then(data => {
                    // console.log(data)
                    let { list, current_page, last_page, per_page, total, resume_view } = data.data;
                    this.list = list.map(v => {
                        return { ...v, defaultimg: `this.src="${require("@/assets/imgs/hello.png")}"` };
                    });
                    this.page = { current_page, last_page, per_page, total };
                    this.resume_view = {  
                        is_active: resume_view.is_active,
                        total_view: resume_view.total_view,
                        view: resume_view.view
                    };
                })
                .catch(err => {
                    // console.log("error: " + err);
                })
            },
            //页码
            pageChange(e) {
                this.par.page = e;
                this.par.limit = 10;
                this.getData(this.par);
            },
            //sortChange
            sortChange(el) {
                this.par.sort_type = el;
                this.getData(this.par);
            },
            //权限提示
            tips(text){
                this.$message({
                    message: text,
                    center: true,
                    showClose: true,
                    duration: 3000,
                    type: 'warning',
                    customClass: 'jsjd'
                });
            },
            //去详情
            gotolink(id,created_at,is_view) {
                if((this.resume_view.view===this.resume_view.total_view)&&is_view===0){
                    return
                }
                if(is_view===0){
                    $api.getResumeDetailsComplete(id)
                    .then(data => {
                        // console.log(data.data.data);
                        if(data.data.status == "204"){
                            this.tips('温馨提示：您好，您暂未购买相关服务，请联系相关工作人员。谢谢 ');
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    })
                }
                sessionStorage.setItem('historyjob'+created_at,created_at)
                this.$router.push({
                    name: "ResumeDetailsForSearch",
                    query: {
                        id: id
                    }
                });
            },
        }
    }
</script>
<style scoped >
    #app {
        background-color: #fff;
        text-align: center;
    }

    .result {
        width: 1080px;
        background: #fff;
        box-sizing: border-box;
        padding: 19px 30px 0 30px;
    }

    .result .result-table {
        position: relative;
        width: 100%;
        margin-top: 10px;
    }

    #app section {
        display: flex;
        width: 100%;
        height: 58px;
        justify-content: flex-end;
        align-items: center;
        border-bottom: 1px solid #F5F6F9;
        background-color: #fff;
        /* padding: 0 30px; */
        box-sizing: border-box;
    }

    .result section h2 {
        display: block;
        font-size: 16px;
        color: #333;
        position: relative;
    }

    .result section h2::after {
        content: "";
        position: absolute;
        width: 65px;
        height: 4px;
        border-radius: 2px;
        bottom: -19px;
        left: 0;
        background: #0077FF;
    }

    .tips{
        font-size: 13px;
        font-family: MicrosoftYaHei;
        color: #FF7247;
        line-height: 13px;
        display: flex;
        justify-content: space-between;
    }
</style>


// WEBPACK FOOTER //
// src/views/resume/personnelsearchresult.vue